/* eslint-disable complexity */
import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';
import classnames from 'classnames';
import combineStyles from '../../../../helpers/combineStyles';
import TypographyStyles from '../../../../styles/typography';
import LayoutStyles from '../../../../styles/layout';
import SpacingStyles from '../../../../styles/helpers/spacing';
import ProgressBar from './ProgressBar';
import DocProgressBar from './DocProgressBar';
import { IconButton, Fade } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/MoreHoriz';
import RefreshIcon from '@material-ui/icons/Refresh';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import StatusStyles from './__styles__/Status.styles';
import StatusLabel from './StatusLabel';
import FlashMessage from '../../../shared/Alerts/Flash/FlashMessage';
import { formatSaleStatusLabel } from '../../../../helpers/utilityFunctions';
import { DOC_REVISION_VERBOSE_STATUS, GeneralWarrantyCases } from '../../../../constants/enums';
import { SALE_TYPES } from '../../../../constants/enums';

export class Status extends Component {
  static propTypes = {
    saleDetail: PropTypes.object.isRequired
  };

  state = {
    menuElement: null,
    isFlashOpen: true
  };

  _handleMenuClick = event => {
    this.setState({ menuElement: event.currentTarget });
  };

  _handleMenuClose = () => {
    this.setState({ menuElement: null });
  };

  _handleCloseFlash = () => {
    this.setState({ isFlashOpen: !this.state.isFlashOpen });
  };

  _permissionsTransfer = () => {
    const { saleDetail } = this.props;
    if (!saleDetail) return false;
    if (
      !saleDetail['hasPendingQuotaTransfer'] &&
      !saleDetail['hasPendingQuotaUnion']
    )
      return false;
    if (saleDetail.quotaTransfers.length == 0) return false;
    if (
      saleDetail.quotaTransfers[0].status == 'registered' &&
      this.props.canReviewTransfer
    ) {
      return 'Revisar';
    }
    if (
      saleDetail.quotaTransfers[0].status == 'reviewed' &&
      this.props.canApproveTransfer
    ) {
      return 'Aprobar';
    }
    return false;
  };

  _getMenuOptions = sale => {
    const { isPreapproveSaleWithPledgeActive, pledgeArticleId, canPreapproveSale } = this.props;
    const isCaseThree = sale.generalWarrantyType === GeneralWarrantyCases.NoHolderWithoutCosigner;

    const pledgeArticle = sale.saleDetails.find(sd => sd.article.id === pledgeArticleId);
    const saleCanBePreapproved = Boolean(pledgeArticle) || isCaseThree;
    const isTraditional = SALE_TYPES.find(type => type.name === 'Tradicional').id === sale.saleType;

    const canDeliverWithPledge = !isPreapproveSaleWithPledgeActive || (saleCanBePreapproved && sale.preApprovedAt && sale.approvedAt || !saleCanBePreapproved && !sale.preApprovedAt);
    const canapproveWithPledge = !isPreapproveSaleWithPledgeActive || (saleCanBePreapproved && sale.preApprovedAt || !saleCanBePreapproved && !sale.preApprovedAt);

    const menuOptions = [];
    if (!sale.canceledAt) {
      if (canDeliverWithPledge && !sale.deliveredAt && this.props.canDeliver && (isTraditional || !isTraditional && sale.approvedAt)) {
        menuOptions.push({
          label: 'Entregar productos',
          action: this._productDelivery
        });
      }
      if (isPreapproveSaleWithPledgeActive && !sale.deliveredAt && !sale.approvedAt && !sale.preApprovedAt && canPreapproveSale && saleCanBePreapproved) {
        menuOptions.push({
          label: 'Preaprobar',
          action: this._preApproveSale
        });
      }
      this._permissionsTransfer() &&
        menuOptions.push({
          label: `${this._permissionsTransfer()} solicitud`,
          action: this._transferRevision
        });
      if (canapproveWithPledge && !sale.approvedAt && this.props.canApproveSale && (saleCanBePreapproved || isTraditional)) {
        menuOptions.push({
          label: 'Aprobar',
          action: this._approveSale
        });
      }
      const hasNoCanceledArticles = sale.saleDetails.some(
        sd => sd.status !== 'canceled'
      );

      if (
        hasNoCanceledArticles &&
        sale.deliveredAt &&
        this.props.canReturnSale
      ) {
        menuOptions.push({
          label: 'Realizar Devolución',
          action: this._returnSale.bind(this, 'Return-Sale')
        });
      }

      if (
        hasNoCanceledArticles &&
        sale.deliveredAt &&
        this.props.canReturnManual
      ) {
        menuOptions.push({
          label: 'Realizar Devolución Manual',
          action: this._returnSale.bind(this, 'Return-SaleManual')
        });
      }

      if (
        hasNoCanceledArticles &&
        !sale.deliveredAt &&
        (this.props.canRevokeSales || this.props.canRevokeArticlesSales)
      ) {
        menuOptions.push({
          label: 'Anular',
          action: this._cancelSale
        });
      }

      if (
        sale.deliveredAt &&
        this.props.canRegisterSinisters &&
        sale.isSecureSale &&
        moment().diff(sale.deliveredAt, 'days', true) >=
        this.props.daysForSinister
      ) {
        menuOptions.push({
          label: 'Registrar siniestro',
          action: this.registerSinister
        });
      }
    }

    return menuOptions;
  };

  _productDelivery = () => {
    this.props.toggleAction('Product-Delivery', true);
    this._handleMenuClose();
  };

  _approveSale = () => {
    this.props.toggleAction('Approve-Sale', true);
    this._handleMenuClose();
  };

  _preApproveSale = () => {
    this.props.toggleAction('PreApprove-Sale', true);
    this._handleMenuClose();
  };

  _returnSale = action => {
    this.props.toggleAction(action, true);
    this._handleMenuClose();
  };

  _cancelSale = () => {
    this.props.toggleAction('Cancel-Sale', true);
    this._handleMenuClose();
  };

  registerSinister = () => {
    this.props.toggleAction('Register-Sinister', true);
    this._handleMenuClose();
  };

  _transferRevision = () => {
    this.props.onOpenRevision('quotaTransferOpen');
    this._handleMenuClose();
  };

  getFlashMessage = saleDetail => {
    if (!saleDetail) return '';
    if (!saleDetail.externalCode) return 'La venta está siendo registrada...';
    if (saleDetail.hasPendingSinister)
      return 'Pendiente por solicitud de siniestro';
  };

  render() {
    const { classes, saleDetail } = this.props;

    const { menuElement, isFlashOpen } = this.state;

    const menuOptions = this._getMenuOptions(saleDetail);
    const message = this.getFlashMessage(saleDetail);
    const hideStatusMenu = saleDetail['hasApprovedSinister'];

    const { documentalRevision } = saleDetail;

    return (
      <div className={classnames(classes.wrapperNoPadding, classes.root)}>
        <div
          className={classnames(
            classes.titleContentDivider,
            classes.titleRowContainer
          )}
        >
          <h2 className={classnames(classes.headline8)}>{'Estado'}</h2>
          <div className={classes.statusTextContainer}>
            <StatusLabel
              label={formatSaleStatusLabel(saleDetail.saleStatus)}
              type={saleDetail.saleStatus}
            />
          </div>
          {documentalRevision && <div className={classes.docStatusContainer}>
            <div className={classes.statusTextContainer}>
              <StatusLabel
                label={Object.values(DOC_REVISION_VERBOSE_STATUS)[documentalRevision.status]}
                type={Object.keys(DOC_REVISION_VERBOSE_STATUS)[documentalRevision.status]}
              />
            </div>
            <div className={classes.docProgressBarContainer}>
              <DocProgressBar
                status={Object.keys(DOC_REVISION_VERBOSE_STATUS)[documentalRevision.status]}
              />
            </div>
          </div>}
          <div className={classes.bannerContainer}>
            {Boolean(message) ? (
              <FlashMessage
                variant="info"
                message={message}
                actionIcon={<RefreshIcon />}
                actionClick={this.props.reFetch}
              />
            ) : (
              <Fragment>
                {saleDetail['hasPendingQuotaTransfer'] && (
                  <Fade in={isFlashOpen} unmountOnExit={true}>
                    <FlashMessage
                      variant="label"
                      message="Solicitud de Traslado pendiente"
                    />
                  </Fade>
                )}
                {saleDetail['hasPendingQuotaUnion'] && (
                  <Fade in={isFlashOpen} unmountOnExit={true}>
                    <FlashMessage
                      variant="label"
                      message="Solicitud de Unión pendiente"
                    />
                  </Fade>
                )}
                {saleDetail['hasApprovedSinister'] && (
                  <Fade in={isFlashOpen} unmountOnExit={true}>
                    <FlashMessage
                      variant="label"
                      message="Solicitud de siniestro aprobada"
                    />
                  </Fade>
                )}
                {saleDetail['hasPendingReturnProcess'] && (
                  <Fade in={isFlashOpen} unmountOnExit={true}>
                    <FlashMessage
                      variant="label"
                      message={`Solicitud de devolución ${saleDetail['returnProcessType'] == 'total'
                        ? 'total'
                        : 'parcial'
                        } pendiente...`}
                    />
                  </Fade>
                )}
                {!hideStatusMenu && (
                  <div className={classes.statusMenu}>
                    <IconButton
                      color="secondary"
                      onClick={this._handleMenuClick}
                    >
                      <MenuIcon />
                    </IconButton>
                  </div>
                )}
              </Fragment>
            )}
          </div>
        </div>
        <div>
          <div className={classes.progressBarContainer}>
            <ProgressBar
              status={saleDetail.saleStatus}
              saleDetail={saleDetail}
              motorbikeCategoryId={this.props.motorbikeCategoryId}
              pledgeArticleId={this.props.pledgeArticleId}
              isPreapproveSaleWithPledgeActive={this.props.isPreapproveSaleWithPledgeActive}
            />
          </div>
        </div>
        {menuOptions.length > 0 && (
          <Menu
            anchorEl={menuElement}
            open={Boolean(menuElement)}
            onClose={this._handleMenuClose}
          >
            {menuOptions.map((option, index) => {
              return (
                <MenuItem
                  key={index}
                  onClick={option.action}
                  selected={index < 1}
                  classes={{
                    selected: classes.selectedItemMenu
                  }}
                >
                  {option.label}
                </MenuItem>
              );
            })}
          </Menu>
        )}
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    paddingBottom: theme.spacing.unit * 3.75
  }
});

export default withStyles(
  combineStyles(
    StatusStyles,
    TypographyStyles,
    SpacingStyles,
    LayoutStyles,
    styles
  )
)(Status);
